<template>
  <!-- -->
  <div class="image-data-setting mini-component">
    <div class="label">{{data.label}}</div>
    <div class="desc">
      设置一段文本，一般用于标题样式，允许添加图标，设置背景图片
    </div>
    <form-items label-width="2.4rem" :columns="1">
      <form-item label="标题文本">
        <el-input v-model="settingData.text" placeholder="请输入文本内容" @change="changeData"/>
      </form-item>
      <form-item label="字体大小" desc-message="通用字体大小为一般为24、32两个尺寸">
        <el-input-number style="width: 100%" v-model="settingData.fontSize" placeholder="请输入文本大小" @change="changeFontSize"/>
      </form-item>
      <form-item label="字体颜色">
        <el-color-picker v-model="settingData.textColor" show-alpha @change="changeData"/>
      </form-item>
      <form-item label="装饰线尺寸" >
        <el-input-number style="width: 100%" v-model="settingData.borderWidthNum" placeholder="请输入尺寸" @change="changeBorderSize"/>
      </form-item>
      <form-item label="装饰线颜色">
        <el-color-picker v-model="settingData.borderColor" show-alpha @change="changeData"/>
      </form-item>
      <form-item label="描述文本">
        <el-input v-model="settingData.desc" placeholder="请输入文本内容" @change="changeData"/>
      </form-item>
      <form-item label="字体大小" desc-message="通用字体大小为一般为24、32两个尺寸">
        <el-input-number style="width: 100%" v-model="settingData.descFontSize" placeholder="请输入文本大小" @change="changeDescFontSize"/>
      </form-item>
      <form-item label="字体颜色">
        <el-color-picker v-model="settingData.descColor" show-alpha @change="changeData"/>
      </form-item>
      <form-item label="标签文本">
        <el-input v-model="settingData.tagName" placeholder="请输入文本内容" @change="changeData"/>
      </form-item>
      <form-item label="字体大小" desc-message="通用字体大小为一般为24、32两个尺寸">
        <el-input-number style="width: 100%" v-model="settingData.tagFontSize" placeholder="请输入文本大小" @change="changeTagFontSize"/>
      </form-item>
      <form-item label="字体颜色">
        <el-color-picker v-model="settingData.tagColor" show-alpha @change="changeData"/>
      </form-item>
    </form-items>
  </div>
</template>

<script>

import AloneData from "@/views/h5/common/sys/miniProgram/setting/component/AloneData.vue";
import FormItems from "@/components/h5/layout/FormItems.vue";
import FormItem from "@/components/h5/layout/FormItem.vue";
export default {
  emits: ["change"],
  props: {
    data: {
      type: Object,
      default: () => {
        return {componentData: {}}
      }
    }
  },
  name: "",
  components: {
    FormItem, FormItems,
    AloneData
  },
  data() {
    return {
      settingData: {
        descFontSize: "",
        descSize: "",
        descColor: "",
        tagFontSize: "",
        tagSize: "",
        tagColor: "",
        borderWidthNum: "",
        borderWidth: "",
      },
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      if (!this.data.componentData) {
        this.settingData = {};
      } else {
        this.settingData = this.data.componentData;
      }
    },
    changeData() {
      this.$emit("change", {...this.data, componentData: this.settingData});
    },
    // 文本大小变更
    changeFontSize() {
      this.settingData.textSize = this.settingData.fontSize? this.settingData.fontSize / 37 + "rem" : "";
      this.changeData();
    },
    changeDescFontSize() {
      this.settingData.descSize = this.settingData.descFontSize? this.settingData.descFontSize / 37 + "rem" : "";
      this.changeData();
    },
    changeTagFontSize() {
      this.settingData.tagSize = this.settingData.tagFontSize? this.settingData.tagFontSize / 37 + "rem" : "";
      this.changeData();
    },
    changeBorderSize() {
      this.settingData.borderWidth = this.settingData.borderWidthNum? this.settingData.borderWidthNum / 37 + "rem" : "0";
      this.changeData();
    }
  }
};
</script>

<style lang="scss" scoped>
.image-data-setting{

}
</style>